import React, { useContext } from 'react';

import { EmailIcon } from 'app/components/shared/icons';

import { PeopleDrawerContext } from '../PeopleDrawerContext';
import { PeopleDrawerContactIconWrapper } from './styled';

export default function PeopleDrawerContactIcon() {
  const { person, setShowContactDrawer } = useContext(PeopleDrawerContext);

  const handleContactClick = () => {
    if (!person || !person.info || person.info.is_alumni) return;

    setShowContactDrawer(true);
  };

  return (
    <PeopleDrawerContactIconWrapper
      onClick={handleContactClick}
      disabled={!person || !person.info || person.info.is_alumni}
    >
      <EmailIcon width={18} height={15} fill="var(--color-primary)" />
    </PeopleDrawerContactIconWrapper>
  );
}
